import { useQuery } from '@tanstack/react-query';
import { fetchAuthState } from '@/lib/auth';

/**
 * " by you" when the actor is the person looking at the screen, and nothing otherwise.
 *
 * The records carry the actor's sign-in id, never a name, and there is no staff directory to turn
 * another person's id into one. An id on screen is noise to HR, so anyone else is simply left out.
 * Real names for other users need a stored name or a directory lookup, which is a decision for
 * Julio (#458 out of scope).
 */
export function byLabel(actorId: string | null | undefined, signedInUserId: string | null): string {
  return actorId !== null && actorId !== undefined && actorId !== '' && actorId === signedInUserId ? ' by you' : '';
}

/**
 * The signed-in user's id, from the same `['auth']` query the layout and the files panel read.
 * `staleTime` is stated here for the reason `useMayReadFiles` states it: this hook subscribes after
 * the page has loaded and must not trigger a refetch.
 */
export function useSignedInUserId(): string | null {
  const auth = useQuery({ queryKey: ['auth'], queryFn: fetchAuthState, retry: false, staleTime: 30_000 });
  return auth.data?.status === 'signed-in' ? auth.data.user.userId : null;
}
